import { Hidden } from '@material-ui/core'
import NavMenuUserIcon from './NavMenuUserIcon'
import PropTypes from 'prop-types'
import React from 'react'
import StyledMenuLink from './StyledMenuLink'
import useStyles from './styles'
import { useAuth0, LoginAction } from 'libs/web-client/utils/auth0/src'

const NavItems = React.forwardRef(({ mobile, openModal, onClose, home }, ref) => {
    const { isAuthenticated, loginWithPopup, logout } = useAuth0()
    const classes = useStyles()

    return (
        <>
            {!home && (
                <>
                    <StyledMenuLink
                        external
                        ref={ref}
                        to={process.env.REACT_APP_COMPANY_WEBSITE_URL}
                        mobile={mobile}
                        id="navbar-home"
                    >
                        Home
                    </StyledMenuLink>
                    <StyledMenuLink ref={ref} to="/support" mobile={mobile} id="navbar-support">
                        Need Help?
                    </StyledMenuLink>
                    <div className={classes.navDivider} />
                </>
            )}

            {isAuthenticated ? (
                <>
                    <Hidden mdUp>
                        <StyledMenuLink
                            ref={ref}
                            to="/account"
                            text="My Account"
                            mobile={mobile}
                            id="navbar-user-settings"
                        />
                        <StyledMenuLink
                            ref={ref}
                            to="/logout"
                            text="Log out"
                            onClick={logout}
                            mobile={mobile}
                            id="navbar-sign-out"
                        />
                    </Hidden>
                    <Hidden smDown>
                        <NavMenuUserIcon openModal={openModal} logout={logout} />
                    </Hidden>
                </>
            ) : (
                <>
                    <StyledMenuLink
                        ref={ref}
                        to="/signin"
                        text="Sign In"
                        onClick={() => {
                            onClose()
                            loginWithPopup({ action: LoginAction.LOGIN })
                        }}
                        mobile={mobile}
                        id="navbar-sign-in"
                    />
                    <StyledMenuLink
                        ref={ref}
                        to="/signup"
                        text="Sign Up"
                        onClick={() => {
                            onClose()
                            loginWithPopup({ action: LoginAction.REGISTER })
                        }}
                        mobile={mobile}
                        id="navbar-sign-up"
                    />
                </>
            )}
        </>
    )
})

NavItems.propTypes = {
    mobile: PropTypes.bool,
    openModal: PropTypes.func.isRequired,
    home: PropTypes.bool,
}

export default React.memo(NavItems)
